export default {
    result: {
        error: 0,
        msg: 'ok'
    },
    content: {
        // 背景音乐
        music_list: [
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650622640131/piano44.MP3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650609598139/volin20.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650622630292/piano42.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650622747531/piano56.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650622772411/piano62.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650873877738/sad2.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650873854729/happy2.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650609152969/volin3.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650622652116/piano48.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650622673160/piano50.mp3',
            'https://cjh-amis.cdn.bcebos.com/2022-4/1650609627745/volin25.mp3'
        ],

        feed_popup: [
            {
                id: 1,
                title: '有你喜欢的内容吗？',
                btn: [
                    {
                        type: 0,
                        text: '有很多'
                    },
                    {
                        type: 1,
                        text: '不太多'
                    }
                ]
            }
        ],
        feed_content: [
            {
                type: 1,
                text: '图片质量较差'
            },
            {
                type: 2,
                text: '音乐不好听'
            },
            {
                type: 3,
                text: '推荐不准'
            },
            {
                type: 4,
                text: '纯图太单调'
            },
            {
                type: 5,
                text: '图片类型太单一'
            }
        ],
        attention_tip: [
            {
                type: 1,
                content: '添加“360度全景”到首页，查看更便捷',
                time: 1668600370,
                url: 'bdapi://duhelperfunc?act=query&id=&name=&callback=',
                icon: 'https://cjh-amis.cdn.bcebos.com/2022-6/1655366396438/3D%E5%AE%9E%E6%99%AFicon.png',
                btn_text: '添加'
            }
        ],

        // 应该删除
        banner: {
            img_url: 'https://cjh-amis.cdn.bcebos.com/2022-9/1664272622298/%E5%85%A8%E6%99%AF%E4%BA%91%E6%B8%B8%E8%BF%90%E8%90%A5%E5%85%A5%E5%8F%A3.png',
            jump_url: 'baidumap://map/cost_share?navigationStatus=2&popRoot=no&hiddenTitle=1&url=http%3A%2F%2Fzhaoziwei-dev.bcc-szth.baidu.com%3A8088%2Fstatic%2Fpano-202210%2Fpano-202210.html%3Ffr%3Dtest',
            show: 'out_app'
        },

        time: Date.now() / 1000, // 单位秒

        // thematic: {
        //     key: 'hongbao',
        //     startTime: 1670198400,
        //     endTime: 1670544000,
        //     content: 'https://cjh-amis.cdn.bcebos.com/2022-12/1670336780878/dialog.png',
        //     link: ''
        // },

        // 漫游下一个按钮样式配置
        next_btn_config: {
            'icon': 'https://cjh-amis.cdn.bcebos.com/2022-12/1670421563398/btn-packet.png',
            'btn_content': '前往新地点',
            'background': 'linear-gradient(74deg, #3377FF 0%, #4EA9FF 100%)'
        },

        thematic: {
            'pop': {
                'key': 'hongbao84',
                'startTime': 1672388429,
                'endTime': 1675066829,
                'content': 'https://cjh-amis.cdn.bcebos.com/2022-12/1672370140223/spring_pop.png',
                'link': '',
                'from_source': [
                    'map_kp',
                    'map_icon',
                    'map_xht',
                    'map_kk',
                    'map_push',
                    'map_hd',
                    'map_xx',
                    'mainpage',
                    'street_bubble'
                ]
            },
            'activity': {
                'startTime': 1672388429,
                'endTime': 1675066829,
                'activity_url': 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8094/activity/spring2023/redenvelope'
            }
        },

        search_tag: '狂飙'
    }
};